import React from 'react';
import classNames from 'classnames';

import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';

import styles from 'assets/jss/material-dashboard-pro-react/components/customRadioStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IRadioProps {
	formControlProps?: object;
	radioProps?: object;
	checked: boolean;
	onChange: () => void;
	name?: string;
	value?: string;
	label?: string | React.ReactNode;
	disabled?: boolean;
}

const CustomRadio = ({
	checked,
	onChange,
	name,
	value,
	label,
	formControlProps,
	radioProps,
	disabled,
}: IRadioProps) => {
	const classes = useStyles();

	const formControlLabelClasses = classNames({
		[classes.label]: true,
		[classes.labelChecked]: checked,
	});

	return (
		<FormControlLabel
			control={
				<Radio
					disabled={disabled}
					checked={checked}
					onChange={onChange}
					value={value}
					name={name}
					aria-label="A"
					color="primary"
					icon={<FiberManualRecord className={classes.radioUnchecked} />}
					checkedIcon={<FiberManualRecord className={classes.radioChecked} />}
					classes={{
						checked: classes.radio,
						root: classes.radioRoot,
						disabled: `${classes.radioDisabled} ${classes.disabledCheckboxAndRadio}`,
					}}
					{...radioProps}
				/>
			}
			classes={{
				label: formControlLabelClasses,
				root: classes.labelRoot,
				disabled: classes.labelDisabled,
			}}
			label={label}
			disabled={disabled}
			{...formControlProps}
		/>
	);
};

export default CustomRadio;
